import { Field, FieldProps, useControlId } from './Field'

export function TextAreaField({
  label,
  error,
  hint,
  labelStyle,
  className,
  style,
  id,
  value,
  onChange,
  rows = 3,
  ...rest
}: FieldProps & {
  value: string
  onChange: (value: string) => void
} & Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'value' | 'onChange' | 'id' | 'className' | 'style'>) {
  const controlId = useControlId(id)

  return (
    <Field label={label} error={error} hint={hint} labelStyle={labelStyle} className={className} style={style} controlId={controlId}>
      <textarea
        id={controlId}
        className="form-control"
        rows={rows}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        {...rest}
      />
    </Field>
  )
}
